import { BatteryStatus, TrackerReadDTO, TrackerType } from '../api/trackers/tracker.contracts';

// TrackerArguments Interface
export interface TrackerArguments {
  id: number;
  type: TrackerType;
  epc?: string | undefined | null;
  barcode?: string | undefined | null;
  deviceId?: string | undefined | null;
  asset?: {
    id: number;
    code: string;
    assetType: {
      id: number;
      code: string;
    };
  };
  location?: {
    id: number;
    code: string;
    name?: string;
  };
  createdAt: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

// TrackerFieldNames enum
export enum TrackerModelFieldNames {
  Id = 'id',
  Name = 'name',
  Type = 'type',
  Code = 'code',
  Epc = 'epc',
  Barcode = 'barcode',
  DeviceId = 'deviceId',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  DeletedAt = 'deletedAt',
}

// Tracker Class
export class TrackerModel {
  id: number;
  type: TrackerType;
  epc?: string | undefined | null;
  barcode?: string | undefined | null;
  deviceId?: string | undefined | null;
  batteryVoltage?: number | undefined | null;
  batteryVoltageUpdatedAt?: Date | undefined | null;
  batteryStatus?: BatteryStatus | undefined | null;
  batteryStatusUpdatedAt?: Date | undefined | null;
  modelType?: string | undefined | null;
  iccid?: string | undefined | null;
  lastEventDate?: Date | undefined | null;
  asset?: {
    id: number;
    code: string;
    assetType: {
      id: number;
      code: string;
    };
  };
  location?: {
    id: number;
    code: string;
    name?: string;
  };
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;

  constructor(args: TrackerReadDTO) {
    this.id = args.id;
    this.type = args.type;
    this.epc = args.epc;
    this.barcode = args.barcode;
    this.deviceId = args.deviceId;
    this.batteryVoltage = args.batteryVoltage;
    this.batteryVoltageUpdatedAt = args.batteryVoltageUpdatedAt;
    this.batteryStatus = args.batteryStatus;
    this.batteryStatusUpdatedAt = args.batteryStatusUpdatedAt;
    this.modelType = args.modelType;
    this.iccid = args.iccid;
    this.asset = args.asset;
    this.location = args.location;
    this.lastEventDate = args.lastEventDate;
    this.createdAt = args.createdAt;
    this.updatedAt = args.updatedAt;
    this.deletedAt = args.deletedAt;
  }

  get uniqueIdentifier(): string {
    switch (this.type) {
      case TrackerType.Barcode:
        return this.barcode ? this.barcode : 'Unknown Tracker';

      case TrackerType.RFID:
        return this.epc ? this.epc : 'Unknown Tracker';

      case TrackerType.Sigfox:
      case TrackerType.BLE:
      case TrackerType.LTE:
        return this.deviceId ? this.deviceId : 'Unknown Tracker';

      default:
        return 'Unknown Tracker';
    }
  }

  toDTO(): TrackerReadDTO {
    return {
      id: this.id,
      type: this.type,
      epc: this.epc,
      barcode: this.barcode,
      deviceId: this.deviceId,
      batteryVoltage: this.batteryVoltage,
      batteryVoltageUpdatedAt: this.batteryVoltageUpdatedAt,
      batteryStatus: this.batteryStatus,
      batteryStatusUpdatedAt: this.batteryStatusUpdatedAt,
      modelType: this.modelType,
      iccid: this.iccid,
      asset: this.asset,
      location: this.location,
      lastEventDate: this.lastEventDate,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      deletedAt: this.deletedAt ? this.deletedAt : undefined,
    };
  }

  static fromDTO(dto: TrackerReadDTO): TrackerModel {
    return new TrackerModel({
      id: dto.id,
      type: dto.type,
      epc: dto.epc,
      barcode: dto.barcode,
      deviceId: dto.deviceId,
      batteryVoltage: dto.batteryVoltage,
      batteryVoltageUpdatedAt: dto.batteryVoltageUpdatedAt,
      batteryStatus: dto.batteryStatus,
      batteryStatusUpdatedAt: dto.batteryStatusUpdatedAt,
      modelType: dto.modelType,
      iccid: dto.iccid,
      asset: dto.asset,
      location: dto.location,
      lastEventDate: dto.lastEventDate,
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt,
      deletedAt: dto.deletedAt,
    });
  }
}
